<template>
    <div>
        <UiOTCookieTables v-editable="blok" :blok="blok" />
    </div>
</template>

<script lang="ts" setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped></style>
